import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'
import employerPreferencesActionTypes from './action-types'
import { EmployerPreferenceEntity } from './types'

export default generateEntityCrudReducer<EmployerPreferenceEntity>({
  name: 'employerPreferences',
  actions: employerPreferencesActionTypes,
  options: { resetEntityDetailOnFetch: true, idKey: 'id' },
})
